<template>
  <v-div class="MatchSet">
    <fieldset>
      <legend
        :class="[
          { 'font-weight-bold': titleBold },
          'v-div',
          'title',
          `${titleColor}--text`,
        ]"
      >
        {{ title }}
      </legend>
      <MatchBucket
        v-for="bucket in buckets"
        :key="bucket.key"
        :bucket="bucket"
        :selected="selected"
        @selectionChanged="$emit('selectionChanged', $event)"
      />
      <v-div border-bottom-inverted-thick mt-3 ml-1 mr-1 />
    </fieldset>
  </v-div>
</template>

<script>
import MatchBucket from "~/components/matches/components/MatchBucket.vue";

export default {
  name: "MatchSet",
  components: {
    MatchBucket,
  },
  props: {
    title: { type: String, required: true },
    titleColor: { type: String, required: true },
    titleBold: { type: Boolean, required: true },
    buckets: { type: Array, required: true },
    selected: { type: Array, required: true },
  },
};
</script>

<style>
.MatchSet > fieldset {
  border: none;
  padding: 0;
  margin: 0;
  word-break: break-word;
}

.MatchSet > fieldset legend {
  border: none;
  padding: 0;
  margin: 0;
  width: fit-content !important;
}
</style>
